// Registro do Service Worker. Só ativa em produção e em navegadores compatíveis.

export function registerServiceWorker() {
  if (process.env.NODE_ENV !== 'production') return;
  if (typeof window === 'undefined') return;
  if (!('serviceWorker' in navigator)) return;

  window.addEventListener('load', () => {
    navigator.serviceWorker
      .register('/service-worker.js')
      .then((registration) => {
        registration.onupdatefound = () => {
          const installing = registration.installing;
          if (!installing) return;
          installing.onstatechange = () => {
            if (installing.state === 'installed' && navigator.serviceWorker.controller) {
              // Nova versão pronta. Próximo reload ativa.
              // Mantemos silencioso para não interromper o fluxo do usuário.
            }
          };
        };
      })
      .catch(() => {
        // Falha silenciosa: app continua funcionando online normalmente.
      });
  });
}

export function unregisterServiceWorker() {
  if (!('serviceWorker' in navigator)) return;
  navigator.serviceWorker.ready
    .then((registration) => registration.unregister())
    .catch(() => undefined);
}
